import React, { useEffect } from 'react'
import {
  Grid,
  makeStyles,
  // Paper,
  // Box,
  // Typography,
  // Avatar,
  Button,
} from '@material-ui/core'
import moment from 'moment-jalaali'
import MUIDataTable from 'mui-datatables'
import { useDispatch, useSelector } from 'react-redux'
import { ThemeProvider } from '@material-ui/core/styles'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { getMuiThemeWithoutPadding } from '../../utils/TableStyle'
import muiDefaultOptions from '../../constants/muiTableOptions'
import {
//   getEventsId,
  getRefereeEvents,
  selectorRefereeEvents,
} from '../../app/slices/eventSlice'
import userEventStatus from '../../constants/eventStatus'

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'row-reverse',
  },
  profile: {
    borderRadius: '1rem',
    padding: '1rem',
  },
  avatar: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gridGap: '1rem',
    alignItems: 'center',
  },
  avatarImage: {
    height: 150,
    width: 150,
  },
  condition: {
    padding: '1rem',
    borderRadius: '1rem',
  },
  description: {
    margin: '1rem 0',
    padding: '1rem',
    border: '.5px solid rgba(0,0,0,.5)',
  },
  listItemTitle: {
    textAlign: 'center',
  },
  list: {
    width: '100%',
    padding: '0 1rem',
    boxShadow: '0 0 1px 0 rgba(26, 24, 24, 0.2)',
    backgroundColor: '#fff',
  },
  listItem: {
    width: '100%',
    display: 'grid',
    gridTemplateColumns: 'repeat(3,1fr)',
    gridColumnGap: theme.spacing(2),
    margin: '1rem 0',
  },
  btn: {
    color: 'white',
    margin: '0 auto',
    borderRadius: theme.spacing(0.9),
    backgroundColor: '#405df0',
    '&:hover': {
      backgroundColor: '#10279b',
    },
  },
}))

const RefereeEventUsersList = () => {
  const classes = useStyles()
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const refereeEvents = useSelector(selectorRefereeEvents)
  const { t } = useTranslation()

  const handleUsers = (state) => {
    // e.preventDefault()
    navigate('user-event', { state })
  }

  useEffect(() => {
    dispatch(getRefereeEvents())
  }, [])

  const columns = [
    {
      name: 'row',
      label: 'ردیف',
      options: {
        sort: false,
        filter: false,
        customBodyRender: (value, { rowIndex }) => {
          return (
            <p style={{
              color: '#000',
              whiteSpace: 'nowrap',
              float: window.outerWidth < 960 ? 'left' : '',
            }}
            >
              {rowIndex + 1}
            </p>
          )
        },
      },
    },
    {
      name: 'event',
      label: 'عنوان رویداد',
      options: {
        customBodyRender: (value) => value?.title,
      },
    },
    {
      name: 'event',
      label: 'موضوع رویداد',
      options: {
        customBodyRender: (value) => value?.subject,
      },
    },
    {
      name: 'event',
      label: 'رده سنی',
      options: {
        customBodyRender: (value) => value?.category?.name,
      },
    },
    {
      name: 'event',
      label: 'تاریخ بستن',
      options: {
        customBodyRender: (value) => (value ? moment(value?.closingDate)?.format('jYYYY/jMM/jDD') : '--'),
      },
    },
    {
      name: 'event',
      label: 'تاریخ انقضا',
      options: {
        customBodyRender: (value) => (value ? moment(value?.expierDate)?.format('jYYYY/jMM/jDD') : '--'),
      },
    },
    {
      name: 'user',
      label: 'کد شرکت کننده',
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value) => value?.userName,
      },
    },
    {
      name: 'status',
      label: 'وضعیت',
      options: {
        filter: true,
        sort: false,
        customBodyRender: (value) => t(userEventStatus[value]),
      },
    },
    {
      name: 'event',
      label: 'مدیریت',
      options: {
        filter: true,
        customBodyRenderLite: (index) => {
          const data = refereeEvents[index]

          return (
            <>
              <Button onClick={() => handleUsers(data)} classes={{ root: classes.btn }}>
                تایید نهایی
              </Button>
            </>

          )
        },
        customBodyRender: () => {
          return (
            <Button onClick={() => handleUsers()} classes={{ root: classes.btn }}>
              تایید نهایی
            </Button>
            // <Link to="/app/events/admin/referee-event-users/user-event">
            //   تایید نهایی
            // </Link>
          )
        },
      },
    },
  ]
  return (
    <Grid container spacing={3} classes={{ root: classes.root }}>
      <Grid item xs={12}>
        <ThemeProvider theme={getMuiThemeWithoutPadding}>
          <MUIDataTable
            data={refereeEvents}
            columns={columns}
            options={{
              ...muiDefaultOptions,
              enableNestedDataAccess: '.',
              filterType: 'multiselect',
              serverSide: true,
              count: refereeEvents?.length,
              onTableChange: (action, state) => {
                console.log(action, state)
              },
              rowHover: true,
              selectableRows: 'none',
              onRowClick: (rowData) => {
                console.log(rowData)
              },
            }}
          />
        </ThemeProvider>
      </Grid>
    </Grid>
  )
}
export default RefereeEventUsersList
